<template>

  <b-modal 
    v-model="isVisible" 
    hide-footer 
    size="lg"
  >
    <b-card cols="12" class="w-90 mr-2">

      <h3 class="text-center">Información del Examen de Laboratorio</h3>

      <div cols="12" class="mb-2" v-if="itemsLs4">
        <hr/>  

        <div> 
          <i class="fas fa-user" style="margin-right: 10px;"/> 
          <b>Paciente:</b> {{ itemsLs4.paciente.identificacion }} - {{ itemsLs4.paciente.nombres }}
        </div>
        
        <div> 
          <i class="fas fa-phone" style="margin-right: 10px;"/> 
          <b>Telefono - correo:</b> {{ itemsLs4.paciente.telefono }} - {{ itemsLs4.paciente.correo }}
        </div>

        <hr>
        <div>
          <i class="fas fa-hospital" style="margin-right: 10px;"/>
          <b>Doctor:</b>  {{ itemsLs4.doctor }}
        </div>

        <div>
          <i class="fas fa-hospital" style="margin-right: 10px;"/>
          <b>Especialidad:</b>  {{ itemsLs4.especialidad }}
        </div>

        <div>
          <i class="fas fa-calendar" style="margin-right: 10px;"/>
          <b>Fecha:</b> {{ itemsLs4.fecha_sol }}
        </div>

         

        <div>
          <i class="fas fa-vial" style="margin-right: 10px;"/>
          <b>Orden AS 400: </b> {{ itemsLs4.ordenas4 }}
        </div> 
        
        <div>
          <i class="fas fa-tag" style="margin-right: 10px;"/>
          <b>Orden Orion: </b>{{ itemsLs4.ordenorion || "No Disponible"}}
        </div>

      </div>


      <div v-if="laboratorios">
        <hr>
        <div class="mb-1"> 
          <i class="fas fa-briefcase-medical mr-1"/> 
          <b>Exámenes:</b> 
        </div>
        
        <div 
          v-for="(item, index) in laboratorios" 
          :key="index" 
          class=""
        > 
          <h6> Cod: {{ item.codigo }} - {{ item.descripcion }}</h6>
        </div>

      </div>


      <div v-if="!isLoading">
        <hr>
        <h6>Documentos: </h6>

        <div 
          v-if="documentosMsp.paciente" 
          class="mb-1"
        >
          <b>MSP Paciente: </b> 
          <b-button 
            size="sm"
            variant="warning" 
            @click="onViewFiles(documentosMsp.paciente)"
          >
            <i class="fa-solid fa-file"/>
          </b-button>

          <!-- {{ documentosMsp.paciente }} -->

        </div>
         

        <div 
          v-if="documentosMsp.titular1"
          class="mb-1"
        >
          <b>MSP Titular 1: </b> 

          <b-button 
            size="sm"
            variant="warning" 
            @click="onViewFiles(documentosMsp.titular1)"
          >
            <i class="fa-solid fa-file"/>
          </b-button>

          <!-- {{ documentosMsp.titular1 }} -->

        </div>
        <div v-else><span class="text-warning">Msp paciente no cargado</span></div>

        <div 
          v-if="documentosMsp.titular2"
          class="mb-1"
        >
          <b>MSP Titular 2: </b> 
          <!-- {{ documentosMsp.titular2 }} -->
          <b-button 
            size="sm"
            variant="warning" 
            @click="onViewFiles(documentosMsp.titular2)"
          >
            <i class="fa-solid fa-file"/>
          </b-button>
        </div>
      </div>

      <hr>

      <div v-if="itemsLs4">
        <b>Resultados:</b>
        <span v-if="!itemsLs4.resultados"> No hay resultados disponibles </span>
        <b-button
          v-if="itemsLs4.resultados"
          size="sm"
          variant="success" 
          @click="onViewFiles(itemsLs4.resultados)"
        >
          <i class="fa-solid fa-file"/>
        </b-button>
      </div> 

      <ModalViewFile
        v-if="fileToView"
        :urlFile="fileToView"
        v-model="isModalFileVisible"
      />

      <GeneralLoader v-if="isLoading"  class="my-5"/>

    </b-card> 
  </b-modal>
  
</template>

<script>
import { BCard } from 'bootstrap-vue';
import { ModalViewFile, GeneralLoader } from '@/shared/components';
import { labAs400Service } from '../services/labAs400Service';
import { laboratoriosService } from '../services/laboratoriosService';

export default {

  name: "ModalViewLab400",

  components: {
    BCard,
    ModalViewFile,
    GeneralLoader
  },

  props: ['idExa', 'idMod'],
  data() {
    return {

      isVisible: false,

      estudiolab: [],
      itemsLs4:null,
      itemsLux:null,
      laboratorios: null,

      documentosMsp:{
        paciente:null,
        titular1:null,
        titular2:null,
      },

      fileToView: null,
      isModalFileVisible: false,

      isLoading: false
    };
  },
  created() {
    this.getDataLab400();
  },
  
  methods: {

    async getDataLab400() {
      this.isLoading = true;

      const urlParams = new URLSearchParams(window.location.search);
      const tokenLaboratorio = urlParams.get("view_laboratorio");
      if(!tokenLaboratorio) return;

      const responseLab400 = await labAs400Service.getByToken(tokenLaboratorio);

      if(!responseLab400){
        await this.$swal.fire({
          icon : 'error',
          title: 'Error',
          text : 'No se pudo obtener la información de la imagen programada'
        });

        this.$router.push({ path: this.$route.path, query: {} })
        return;
      }

      
      const lab400 = responseLab400;

      this.documentosMsp = {
        paciente: lab400.urlMspCalificacion,
        titular1: lab400.urlMspCalificacion1,
        titular2: lab400.urlMspCalificacion2,
      };

      const dataCita = lab400.estudiolab.consultamedica.cita;
      const dataPaciente = dataCita.paciente.persona;

      const paciente = {
        identificacion: dataPaciente.identificacion,
        nombres       : `${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`,
        telefono      : dataPaciente.telefono,
        correo        : dataPaciente.correo
      };

      this.itemsLs4 = {
        doctor:       `${dataCita.doctor.idPersona.primerApellido} ${dataCita.doctor.idPersona.primerNombre}`,
        paciente,
        fecha_sol:    `${dataCita.fechaCita}`,
        especialidad: `${dataCita.doctor.especialidad.descripcion}`,
        ordenas4:     `${lab400.numeroOrden}`,
        ordenorion:   `${lab400.nordenEnterprise}`,
        examenes:     lab400.idslaboratorios.split(','),
        resultados:   lab400.urlInformeEnterprise
      };

      console.log('itemsLs4', this.itemsLs4);

      this.laboratorios = await laboratoriosService.searchMultiplesLaboratoriosById(this.itemsLs4.examenes);
      this.isLoading = false;
      this.isVisible = true;
    },

    onViewFiles(url) {
      this.fileToView = url;
      this.isModalFileVisible = true;
    },

  },

  watch: {
    '$route.query.view_laboratorio': {
      handler(){
        this.getDataLab400();
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.view_laboratorio;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  },

};
</script>